var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoDocumentUi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.542,
    height: 20.677,
    viewBox: "0 0 16.542 20.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-document-ui",
    d: "M16.406,2l4.135,4.135H16.406ZM14.339,8.2h6.2v13.44a1.034,1.034,0,0,1-1.034,1.034H5.034A1.034,1.034,0,0,1,4,21.643V3.034A1.034,1.034,0,0,1,5.034,2h9.3ZM7.1,6.135A1.034,1.034,0,0,0,8.135,7.169h3.1a1.034,1.034,0,1,0,0-2.068h-3.1A1.034,1.034,0,0,0,7.1,6.135ZM17.44,18.542a1.034,1.034,0,0,0-1.034-1.034H8.135a1.034,1.034,0,1,0,0,2.068h8.271A1.034,1.034,0,0,0,17.44,18.542Zm-9.3-5.169a1.034,1.034,0,0,0,0,2.068h8.271a1.034,1.034,0,1,0,0-2.068Z",
    transform: "translate(-4 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoDocumentUi);
export default __webpack_public_path__ + "static/media/so-document-ui.dd2508b78719d57542d31e0364f9416e.svg";
export { ForwardRef as ReactComponent };